(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-section"] && !Shopify.designMode) return;
  try {
    
  // Light Theme Product Description Animation Controller
  class ProductDescriptionAnimations {
    constructor() {
      this.animatedElements = new Set();
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupAnimations());
      } else {
        this.setupAnimations();
      }
    }

    setupAnimations() {
      this.createObserver();
      this.triggerInitialAnimations();
    }

    createObserver() {
      const options = {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.1,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
            this.triggerAnimation(entry.target);
            this.animatedElements.add(entry.target);
          }
        });
      }, options);

      document.querySelectorAll('.pds-animate').forEach((el) => {
        observer.observe(el);
      });
    }

    triggerAnimation(element) {
      const animationType = element.getAttribute('data-animate');
      const delay = parseInt(element.getAttribute('data-delay')) || 0;

      setTimeout(() => {
        element.classList.add('animate');
      }, delay);
    }

    triggerInitialAnimations() {
      // Trigger hero animations immediately
      const hero = document.querySelector('.pds-hero');
      if (hero) {
        hero.style.animationDelay = '0.3s';
      }
    }
  }

  // Initialize animations when the section loads
  new ProductDescriptionAnimations();

  } catch(e) { console.error(e); }
})();
})();
